module.exports = __webpack_public_path__ + "img/terroir-bright-3.12cf199d.jpg";